export default "__VITE_ASSET__Bf78dtpx__"